import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import ListParentRecognition from '../list/list-parent-recognition';
import { ConfigurationType } from 'civil-status/constants/configuration-type';

interface ParentRecognitionProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  controllParentRecognitionMadrePadreRiconoscimento: (parentRecognition?: string) => void;
  configuration?: string;
}

const ParentRecognitionComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
  controllParentRecognitionMadrePadreRiconoscimento,
  configuration,
}: ParentRecognitionProps): React.ReactElement => {
  const isRicGenit = useMemo(() => {
    return configuration === ConfigurationType.RICGENIT;
  }, [configuration]);

  const handleListParentRecognition = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('parentRecognition', event.target.value);
  });

  useEffect(() => {
    controllParentRecognitionMadrePadreRiconoscimento(values?.parentRecognition);
  }, [values?.parentRecognition]);

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <ListParentRecognition
          value={values?.parentRecognition || ''}
          onChange={handleListParentRecognition}
          disabled={disabled}
          error={Boolean(errors?.parentRecognition) && touched?.parentRecognition}
          required
          withoutEntrambi={isRicGenit}
        />
      </Grid>
    </Grid>
  );
};

ParentRecognitionComponent.displayName = 'Form Parent Recognition component';

const ParentRecognition = memo(ParentRecognitionComponent);

export default ParentRecognition;
